import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "border-b-2 border-[#F5F2EB] bg-[#0A0A0A]/95 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="flex h-16 items-center justify-between px-6 md:px-12 lg:px-20">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-serif text-2xl font-black tracking-tight"
        >
          JFLY<span className="text-[#FF3B1F]">®</span>
        </button>
        <nav className="flex items-center gap-5 text-[10px] font-mono font-medium uppercase tracking-[0.2em] text-[#F5F2EB]/70 md:gap-8 md:text-xs">
          <button data-testid="nav-shop-link" onClick={() => go("shop")} className="transition-colors hover:text-[#FF3B1F]">
            Shop
          </button>
          <button data-testid="nav-manifesto-link" onClick={() => go("manifesto")} className="hidden transition-colors hover:text-[#FF3B1F] sm:inline">
            Why
          </button>
          <button data-testid="nav-contact-link" onClick={() => go("contact")} className="transition-colors hover:text-[#FF3B1F]">
            Contact
          </button>
          <Link
            data-testid="nav-admin-link"
            to="/admin/login"
            className="rounded-full border-2 border-[#F5F2EB] bg-[#141414] px-3 py-1 text-[#F5F2EB] transition-all hover:bg-[#F5F2EB] hover:text-black"
          >
            Admin
          </Link>
        </nav>
      </div>
    </header>
  );
};
